<template>
  <v-container id="user-profile" fluid tag="section">
    <validation-observer v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(validateForm)">
        <v-row justify="center">
          <v-col cols="12" md="8">
            <base-material-card color="gold" inline title="Jugador">
              <template v-slot:after-heading>
                <div class="font-weight-light card-title mt-2">
                  {{ tittle }}
                </div>
              </template>
              <v-container class="py-0">
                <v-row>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="nombre" rules="required|max:45">
                      <v-text-field v-model="dataForm.user.name" color="gold" :error-messages="errors" label="Nombre *" :readonly="mode === 'show'" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="apellido" rules="max:45">
                      <v-text-field v-model="dataForm.user.lastname" color="gold" :error-messages="errors" label="Apellido" :readonly="mode === 'show'" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="dni" rules="required|max:10|numerico|sinpuntos">
                      <v-text-field v-model="dataForm.user.dni" color="gold" :error-messages="errors" label="Dni *" :readonly="mode === 'show'" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="celular" rules="max:25">
                      <v-text-field v-model="dataForm.user.celular" color="gold" :error-messages="errors" label="Celular" :readonly="mode === 'show'" />
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="email" rules="max:45|email">
                      <v-text-field v-model="dataForm.user.email" color="gold" :error-messages="errors" label="Email" :readonly="mode === 'show'" />
                    </validation-provider>
                  </v-col>

                  <v-col cols="6">
                    <validation-provider v-slot="{ errors }" name="domicilio" rules="required|max:45">
                      <v-text-field v-model="dataForm.user.domicilio" color="gold" :error-messages="errors" label="Domicilio *" :readonly="mode === 'show'" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y :disabled="mode === 'show'">
                      <template v-slot:activator="{ on }">
                        <validation-provider v-slot="{ errors }" name="fecha nacimiento" rules="required">
                          <v-text-field v-model="dataForm.fecha_nacimiento" prepend-inner-icon="mdi-calendar-outline" color="gold" :error-messages="errors" label="Fecha nacimiento *" readonly v-on="on" />
                        </validation-provider>
                      </template>
                      <v-date-picker v-model="dataForm.fecha_nacimiento" color="gold" landscape scrollable locale="es-419" no-title @input="menu = false" />
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="pasaporte" rules="required">
                      <v-select v-model="dataForm.pasaporte_id" color="gold" :error-messages="errors" label="Pasaporte *" item-value="id" item-text="descripcion" :items="pasaportes" :readonly="mode === 'show'">
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.descripcion" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="posicion" rules="required">
                      <v-select
                        v-model="dataForm.posicion_detalle_id"
                        color="gold"
                        :error-messages="errors"
                        label="Posicion *"
                        item-value="id"
                        item-text="descripcion"
                        :items="posicionesDetalle"
                        :readonly="mode === 'show'"
                      >
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.descripcion" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="pierna habil" rules="required">
                      <v-select v-model="dataForm.pierna_habil" color="gold" item-color="gold" label="Pierna habil *" :items="piernas" :error-messages="errors" :readonly="mode === 'show'">
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="4">
                    <validation-provider v-slot="{ errors }" name="altura" rules="max:25">
                      <v-text-field v-model="dataForm.altura" color="gold" type="number" step="0.01" suffix="m" :error-messages="errors" label="Altura" :readonly="mode === 'show'" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="4">
                    <validation-provider v-slot="{ errors }" name="peso" rules="max:25">
                      <v-text-field v-model="dataForm.peso" color="gold" type="number" step="0.01" suffix="Kg" :error-messages="errors" label="Peso" :readonly="mode === 'show'" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="4">
                    <validation-provider v-slot="{ errors }" name="talle calzado" rules="max:25">
                      <v-text-field v-model="dataForm.talle_calzado" color="gold" type="number" step="0.01" :error-messages="errors" label="Talle calzado" :readonly="mode === 'show'" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12">
                    <validation-provider v-slot="{ errors }" name="descripcion" rules="max:250">
                      <v-textarea v-model="dataForm.user.obs" color="gold" :error-messages="errors" name="input-6-1" label="Observaciones" :readonly="mode === 'show'" />
                    </validation-provider>
                  </v-col>

                  <v-col cols="12">
                    <v-row justify="space-between">
                      <v-checkbox v-if="mode !=='show'" v-model="notificar" :disabled="!showNotificar" color="gold" label="Notificar al guardar" class="ml-3" />
                      <v-btn v-if="mode !=='show'" :disabled="$disabled()" color="gold" class="mr-0" type="submit">
                        Guardar
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </base-material-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="v-card--material pa-3">
              <div class="d-flex grow flex-wrap">
                <v-avatar size="128" class="mx-auto v-card--material__avatar elevation-6" color="grey">
                  <base-upload-files folder="/users" :documento-id="dataForm.user.documentacion_id" avatar public tipo="imagen" @documento="dataForm.user.documentacion_id = $event" />
                </v-avatar>
              </div>
              <v-card-text class="text-center">
                <h6 class="display-1 mb-1 grey--text">
                  {{ posicionDetalle.descripcion }}
                </h6>
                <h4 class="display-2 font-weight-light mb-3 black--text">
                  {{ dataForm.user.name }} &nbsp;  {{ dataForm.user.lastname }}
                </h4>
                <p class="font-weight-light grey--text">
                  {{ dataForm.user.obs }}
                </p>
              </v-card-text>
            </v-card>
            <v-card class="mt-3">
              <v-card-subtitle>Contacto padres</v-card-subtitle>
              <v-divider />
              <v-row class="pr-4 pl-4 pb-1">
                <v-col cols="12" md="6">
                  <validation-provider v-slot="{ errors }" name="nombre padre" rules="max:25">
                    <v-text-field v-model="dataForm.celular_padre" color="gold" :error-messages="errors" label="Nombre padre" :readonly="mode === 'show'" />
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="6">
                  <validation-provider v-slot="{ errors }" name="celular padre">
                    <v-text-field v-model="dataForm.padre" color="gold" :error-messages="errors" label="Celular padre" :readonly="mode === 'show'" />
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="6">
                  <validation-provider v-slot="{ errors }" name="nombre madre" rules="max:25">
                    <v-text-field v-model="dataForm.celular_madre" color="gold" :error-messages="errors" label="Nombre madre" :readonly="mode === 'show'" />
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="6">
                  <validation-provider v-slot="{ errors }" name="celular madre">
                    <v-text-field v-model="dataForm.madre" color="gold" :error-messages="errors" label="Celular madre" :readonly="mode === 'show'" />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="mt-3">
              <v-card-subtitle>Scout</v-card-subtitle>
              <v-divider />
              <v-row class="pa-4">
                <v-col cols="12" class="pt-1 pb-1">
                  <v-select
                    v-model="dataForm.scout_id"
                    :items="scouts"
                    item-value="user_id"
                    item-text="fullName"
                    label="Scout"
                    color="gold"
                    clearable
                    :readonly="mode === 'show'"
                  >
                    <template v-slot:item="{ attrs, item, on }">
                      <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.fullName" />
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="mt-3">
              <v-card-subtitle>Roles y permisos</v-card-subtitle>
              <v-divider />
              <v-row class="pa-3">
                <v-col cols="12" class="pt-0 pb-0">
                  <validation-provider v-slot="{ errors }" name="role" rules="required">
                    <v-select v-model="dataForm.user.rolese" :items="roles" :error-messages="errors" attach chips label="Roles *" multiple :readonly="mode === 'show'" />
                  </validation-provider>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0">
                  <v-select v-model="dataForm.user.permisos" :items="permissions" attach chips label="Permisos" multiple :readonly="mode === 'show'" />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
  </v-container>
</template>

<script>
  export default {
    props: {
      mode: {
        type: String,
        required: true,
      },
      id: {
        type: Number,
        required: false,
        default: 0,
      },
    },

    data: () => ({
      tittle: 'Nuevo usuario',
      menu: false,
      newFile: null,
      showNotificar: false,
      notificar: false,
      piernas: ['Izquierda', 'Derecha'],
      posicionesDetalle: [],
      pasaportes: [],
      roles: [],
      permissions: [],
      scouts: [],
      dataForm: {
        id: '',
        fecha_nacimiento: '',
        altura: '',
        peso: '',
        talle_calzado: '',
        posicion_detalle_id: '',
        pierna_habil: '',
        pasaporte_id: '',
        padre: '',
        celular_padre: '',
        madre: '',
        celular_madre: '',
        scout_id: '',
        user_id: '',
        user: {
          id: '',
          dni: '',
          name: '',
          lastname: '',
          domicilio: '',
          celular: '',
          email: '',
          obs: '',
          documentacion_id: 0,
        },
      },
    }),
    computed: {
      posicionDetalle: function () {
        return this.posicionesDetalle.find(posicionDetalle => posicionDetalle.id === this.dataForm.posicion_detalle_id) || ''
      },
      pasaporte: function () {
        return this.pasaportes.find(pasaporte => pasaporte.id === this.dataForm.pasaporte_id) || ''
      }, /// esto para que esta???
    },
    watch: {
      'dataForm.user.email' (val) {
        if (val === '') {
          this.showNotificar = false
        } else {
          this.showNotificar = true
        }
      },
      newFile (val) {
        if (val !== null) {
          this.$emit('fileChange', val)
        }
        this.dataForm.documento_id = this.newFile
      },
    },

    created () {
      this.setTittle()
      if (this.mode !== 'new') {
        this.getJugador()
      }
      this.getPosiciones()
      this.getPasaportes()
      this.getRoles()
      this.getPermissions()
      this.getScouts()
    },
    methods: {
      setTittle: function () {
        if (this.mode === 'new') {
          this.tittle = 'Nuevo usuario'
        } else if (this.mode === 'show') {
          this.tittle = 'Informacion usuario'
        } else {
          this.tittle = 'Editar usuario'
        }
      },
      getPosiciones: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/posicion_detalle_get' }).then(response => { this.posicionesDetalle = response })
      },
      getPasaportes: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/pasaporte_get' }).then(response => { this.pasaportes = response })
      },
      getRoles: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/role_names_get' }).then(response => { this.roles = response })
      },
      getPermissions: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/permisos_get' }).then(response => { this.permissions = response })
      },
      getScouts: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get_scout' }).then(response => { this.scouts = response })
      },
      getJugador: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador_get/' + this.id }).then(response => { this.dataForm = response })
      },
      validateForm (scope) {
        this.enviarJugador()
      },
      enviarJugador: async function () {
        const mode = this.mode === 'new' ? 'postData' : 'putData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/jugador_agregar', dataForm: this.dataForm }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de jugador exitosa'] })
          if (this.dataForm.user.email != null && this.dataForm.user.email !== '' && this.notificar) {
            this.$store.dispatch('axiosMod/sendMailResetPassword', this.dataForm.user.email)
          }
          this.$router.push({ path: '/ver/jugadores' })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
          } else if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        /* let method = ''
        let id = ''
        let message = ''
        if (this.mode === 'new') {
          method = 'post'
          message = ['Alta de usuario exitosa']
        } else {
          method = 'put'
          message = ['Edición de usuario exitosa']
          id = '/' + this.dataForm.id
        }
        await this.$http({
          method: method,
          url: '/api/jugador' + id,
          data: {
            ...this.dataForm,
          },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: message })
          if (this.dataForm.user.email != null && this.dataForm.user.email !== '' && this.notificar) {
            this.$store.dispatch('axiosMod/sendMailResetPassword', this.dataForm.user.email)
          }
          this.$router.push({ path: '/ver/jugadores' })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        }) */
      },

    },
  }
</script>
